module.exports = __webpack_public_path__ + "static/img/M83K-PF_A.27fe974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/M83K-PF_A.jpg
// module id = CpZa
// module chunks = 0